import styled from "styled-components"
import BannerSection from "."

interface BannerProps{
	backGroundColor?: string
	titleColor?: string
	subTitleColor?: string
}

export const BannerSectionWrapper = styled.div.withConfig({
	shouldForwardProp: (prop) => !['backGroundColor', 'titleColor', 'subTitleColor'].includes(prop),
})<BannerProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: ${(props: BannerProps) => props.backGroundColor};
	padding: 14px 24px;
	margin: -24px;
	margin-bottom: 38px;
	gap: 24px;
	.containerMessage {
		display: grid;
		grid-template-columns: 26px 1fr;
		grid-template-rows: 1fr;
		gap: 8px;
		.icon {
			width: 26px;
			height: 26px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		}
		.textInfo {
		display: flex;
		flex-direction: column;
			font-size: 14px;
			font-weight: 400;

		.title {
			font-size: 14px;
			font-weight: 700;
			color: ${(props: BannerProps) => props.titleColor};
		}
		.description {
			font-size: 14px;
			font-weight: 400;
			color: ${(props: BannerProps) => props.subTitleColor};
		}
	}
	.containerActions {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 24px;
		.buttonPay {
			font-size: 14px;
			font-weight: 400;
			line-height: 16.8px;
			padding: 10px 12px;
			color: #fff;
			background-color: #5b3fff;
			border-radius: 20px;
			white-space: nowrap;
			cursor: pointer;
		}
	}
`
